import React from "react";

export type UserData = {
  access_token: string;
  refresh_token: string;
  user: {
    avatar: string | null;
    email: string;
    id: number;
    name: string;
    role: string;
  };
};

interface IUserContext {
  user: UserData;
  setUser: React.Dispatch<React.SetStateAction<UserData>>;
  setAuthPersist: (user: UserData) => void;
  authCheck: () => boolean;
}

const UserContext = React.createContext<IUserContext>({} as IUserContext);

export default UserContext;
